<template>
  <div>
    <vs-row vs-type="flex">
      <vs-col
        v-for="(cd,index) in cardData"
        :key="index"
        class="sm:w-full lg:w-1/3 p-3"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
      >
        <vs-card class="p-2 mb-2 items-center">
          <div class="mt-3 mb-3" slot="media">
            <span
              class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"
              style="background: rgba(var(--vs-success), 0.15)"
            >
              <img
                :src="cd.img"
                :alt="cd.title"
                width="40px"
                height="40px"
              />
            </span>
          </div>
          <div class="items-center mb-0">
            <h4 class="card-title mb-3">{{cd.title}}</h4>
            <p class="card-description">
              {{cd.description}}
            </p>
          </div>
        </vs-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
export default {
    name: "VerticalCardThreeLevel_Icon",
    props: ['cardData']
};
</script>

<style scoped>
.feature-title {
    font-style: normal;
    font-weight: 800;
    font-size: 20px;
    line-height: 27px;
    text-align: center;
    color: #231D4F;
    flex: none;
    order: 0;
    flex-grow: 0;
    /*margin: 0px 10px;*/
  }

  .feature-description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 26px;
    text-align: center;
    color: #848199;
    flex: none;
    order: 1;
    flex-grow: 0;
    /*margin: 0px 10px;*/
  }
</style>